import styled from "styled-components";

export const AssistanceLinkHelp = styled.span(({ theme }) => ({
    marginLeft: theme.spacing.xxSmall,
    color: theme.colors[theme.colorMode].primary,
}));
